import { handleBigFont, setFontInfoInCache } from './big-font';
import { FontScaleObserver } from './font-scale-observer';

/**
 * 初始化大字体缩放处理相关
 * 1、写入大字体缩放css变量，便于后续css控制大字体展示
 * 2、页面进入时大字体闪动处理
 */
export function initFontScale() {
  // 写入css变量
  new FontScaleObserver((fontScale) => {
    document.documentElement.style.setProperty('--font-scale', `${fontScale}`);
    setFontInfoInCache(fontScale);
  });
  // 禁止页面大字体闪动
  handleBigFont();
}
